export type QuestionType = 'radio' | 'checkbox';

export type QcmResponse = {
  idx?: number;
  id?: number;
  responseText?: string;
  score?: number | null;
  isOther?: boolean;
};

export type QcmItem = {
  idx?: number;
  question?: string;
  type?: QuestionType;
  response?: QcmResponse[];
};

export type EbookContentBlock = {
  bloc_template?: number;
  title?: string;
  paragraphe?: string;
  encyclopedia?: string | null;
  free_question_title?: string;
  author?: string;
  title_type?: string;
  img?: { id?: number | string; url?: string } | null;
  qcm?: QcmItem[];
  qcm_title?: string;
  value?: string;
  numLines?: number;
  styleEditor?: unknown;
  contentForType?: 'normal' | 'citation' | 'encyclopedia';
  citation?: string;
  alignement?: string;
  videoBook?: string;
  videoBookEn?: string;
  autoPlayVideo?: number | null;
  muteVideo?: number | null;
  autoPlayVideoEn?: number | null;
  muteVideoEn?: number | null;
  imgLink?: string;
  checkedLink?: boolean;
  showLinkPopup?: boolean;
};

export const QUESTION_TYPE_OPTIONS: { value: QuestionType; label: string }[] = [
  { value: 'radio', label: 'Choix unique' },
  { value: 'checkbox', label: 'Choix multiple' },
];

export const getQuestionType = (block: EbookContentBlock): QuestionType =>
  block?.qcm?.[0]?.type === 'checkbox' ? 'checkbox' : 'radio';

export const createEmptyBlock = (blocTemplate: number): EbookContentBlock => ({
  bloc_template: blocTemplate,
  title: '',
  paragraphe: '',
  encyclopedia: null,
  free_question_title: '',
  author: '',
  title_type: blocTemplate === 2 ? 'title' : '',
  img: null,
  qcm: [],
  value: '',
  numLines: 7,
  styleEditor: null,
  contentForType: 'normal',
  citation: '',
  alignement: 'flex-start',
  videoBook: '',
  imgLink: '',
  checkedLink: false,
});

const resolveBlocTemplateId = (blocTemplate: unknown): number | undefined => {
  if (typeof blocTemplate === 'number') {
    return blocTemplate;
  }

  if (blocTemplate && typeof blocTemplate === 'object' && 'id' in blocTemplate) {
    return (blocTemplate as { id: number }).id;
  }

  return undefined;
};

export const normalizeEbookContentBlocks = (content: unknown): EbookContentBlock[] => {
  if (!Array.isArray(content)) {
    return [];
  }

  return content.map(block => {
    if (!block || typeof block !== 'object') {
      return {};
    }

    const { bloc_template: blocTemplate, ...rest } = block as {
      bloc_template?: unknown;
    };

    return {
      ...rest,
      bloc_template: resolveBlocTemplateId(blocTemplate),
    } as EbookContentBlock;
  });
};
